<div *ngIf="!isStarterUser">
  <div class="col-md-3">
    <grouping-side-nav
      [dataConfigs]="dataConfigs"
      [selectedDataConfig]="selectedDataConfig"
      (selectNewDataConfig)="selectNewDataConfig($event)"
    >
    </grouping-side-nav>
  </div>
  <div class="col-md-9">
    <grouping-body
      [selectedDataConfig]="selectedDataConfig"
      *ngIf="selectedDataConfig && selectedDataConfig.groupingTemplateId"
    ></grouping-body>
    <official-enrollment-rules
      *ngIf="
        selectedDataConfig &&
        selectedDataConfig.displayName == 'Official Enrollment Rules'
      "
    ></official-enrollment-rules>
    <graduation-plan-configuration
      *ngIf="
        selectedDataConfig &&
        selectedDataConfig.displayName == 'Graduation Plan'
      "
    ></graduation-plan-configuration>
  </div>
</div>
